// src/vocabulary/A2/unit4/questions.js

const questions = [
  // 🟢 Easy – meaning
  {
    id: 1,
    type: "choice",
    question: "What does 'listen to music' mean?",
    options: ["يشاهد أفلام", "يستمع إلى الموسيقى", "يلعب كرة قدم"],
    correctAnswer: "يستمع إلى الموسيقى"
  },

  {
    id: 2,
    type: "choice",
    question: "Which activity uses 'play'?",
    options: ["play football", "play movies", "play books"],
    correctAnswer: "play football"
  },

  // 🟡 Medium – daily usage
  {
    id: 3,
    type: "choice",
    question: "Choose the correct sentence:",
    options: [
      "I listen music every day.",
      "I listen to music every day.",
      "I music listen every day."
    ],
    correctAnswer: "I listen to music every day."
  },

  {
    id: 4,
    type: "choice",
    question: "What do people often do on weekends?",
    options: [
      "Go out with friends",
      "Go to school",
      "Go to the office at night"
    ],
    correctAnswer: "Go out with friends"
  },

  // 🔵 Harder – logic & meaning
  {
    id: 5,
    type: "choice",
    question: "Which sentence shows a hobby?",
    options: [
      "I travel during the summer.",
      "I am eating dinner now.",
      "I am at home."
    ],
    correctAnswer: "I travel during the summer."
  },

  {
    id: 6,
    type: "choice",
    question: "When do people usually relax?",
    options: [
      "In their free time",
      "During exams",
      "At work meetings"
    ],
    correctAnswer: "In their free time"
  }
];

export default questions;


